import React from 'react';
import PropTypes from 'prop-types';

import { DndIcon } from '../../Icons/Icons';

import './drag-handle.scss';

const DragHandle = (props) => {
    const { isVisible, ...otherProps } = props;

    return (
        isVisible ?
            <span
                {...otherProps}
                className="drag-handle"
            >
                <DndIcon
                    width={7}
                    height={10}
                />
            </span>
            :
            null
    );
};

DragHandle.propTypes = {
    isVisible: PropTypes.bool.isRequired,
};

export default DragHandle;
